// hooks/useLoginFlow.js
import { useState, useEffect } from "react";
import { useOktaAuth } from "@okta/okta-react";
import { useDispatch, useSelector } from "react-redux";
import { setConfig } from "../slices/configSlice";

const useLoginFlow = () => {
  const { authState, oktaAuth } = useOktaAuth();
  const dispatch = useDispatch();
  const { External } = useSelector((store) => store.config);

  const login = async () => {
    await oktaAuth.signInWithRedirect();
  };

  useEffect(() => {
    dispatch(setConfig(null));
  }, []);

  useEffect(() => {
    if (authState && External !== null) {
      login();
    }
  }, [External]);

  const switchToInternal = () => dispatch(setConfig(true));
  const switchToExternal = () => dispatch(setConfig(false));

  return {
    switchToInternal,
    switchToExternal,
  };
};

export default useLoginFlow;
